module.exports = __webpack_public_path__ + "img/about-2.9d3d4205.png";